var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEmailinline = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 2h24v18a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2Zm22.91 1H23v17a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V3h.09l9.559 8.761a2 2 0 0 0 2.702 0L22.91 3Zm-1.48 0H2.57l8.754 8.024a1 1 0 0 0 1.352 0L21.429 3Z",
  fill: "#252829"
})));
export default SvgEmailinline;